import JSZip from 'jszip'
import { CustomComponentLibrariesLibraryIdRevisionsPostVersionBumpEnum } from '../../retool_client'
import { CustomComponentLibraryWrappedClient } from '../../customComponentLibraryWrappedClient'

export async function syncRevisions(
  libraryId: string,
  originClient: CustomComponentLibraryWrappedClient,
  targetClient: CustomComponentLibraryWrappedClient,
  verbose = false,
) {
  const originRevisions = await originClient.customComponentLibrariesLibraryIdRevisionsGet({
    libraryId,
  })
  const targetRevisions = await targetClient.customComponentLibrariesLibraryIdRevisionsGet({
    libraryId,
  })
  const existingTargetRevisitons = new Set()
  targetRevisions.data.forEach((revision) => existingTargetRevisitons.add(revision.id))

  for (const originRevision of originRevisions.data) {
    if (!existingTargetRevisitons.has(originRevision.id)) {
      process.stdout.write(`Syncing version ${originRevision.version}... `)
      const filesResponse = await originClient.customComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet({
        libraryId,
        revisionId: originRevision.id,
      })
      const zip = new JSZip()

      for (const file of filesResponse.data) {
        zip.file(file.filepath, file.fileContents)
      }

      const zipFile = await zip.generateAsync({ type: 'blob' })
      try {
        await targetClient.customComponentLibrariesLibraryIdRevisionsPost({
          files: zipFile,
          libraryId,
          id: originRevision.id,
          versionBump: CustomComponentLibrariesLibraryIdRevisionsPostVersionBumpEnum.SpecifyVersion,
          version: originRevision.version,
        })
        console.log('Success')
      } catch (e) {
        console.log('Failed')
        if (verbose) {
          console.error('\n--- Verbose Error Details ---')
          if (e instanceof Error) {
            console.error('Error Name:', e.name)
            console.error('Error Message:', e.message)
            if (e.stack) {
              console.error('Stack Trace:', e.stack)
            }
          }
          
          // Try to get response details if available
          if (e && typeof e === 'object' && 'response' in e) {
            const response = (e as any).response
            if (response) {
              console.error('Response Status:', response.status)
              console.error('Response Status Text:', response.statusText)
              console.error('Response URL:', response.url)
              
              try {
                const responseBody = await response.json()
                console.error('Response Body:', JSON.stringify(responseBody, null, 2))
              } catch (bodyError) {
                try {
                  const responseText = await response.text()
                  console.error('Response Body (text):', responseText)
                } catch (textError) {
                  console.error('Could not read response body')
                }
              }
            }
          }
          console.error('Full Error Object:', e)
          console.error('--- End Verbose Details ---\n')
        } else {
          // Non-verbose mode - try to show basic error info
          if (e && typeof e === 'object' && 'response' in e) {
            try {
              const responseBody = await (e as any).response.json()
              console.log('Error:', responseBody)
            } catch {
              console.log('Error occurred but could not parse response')
            }
          } else {
            console.log('Error:', e)
          }
        }
      }
    }
  }
}
